import { getDashboardHostApiInternal } from "./DashboardHostImpl";
export function getUserGeoName() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.userGeoName;
    }
    else {
        return "";
    }
}
export function getGeoLocationCode() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.geoLocationCode;
    }
    else {
        return "";
    }
}
export function isInCTARegion() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isInCTARegion;
    }
    else {
        return false;
    }
}
export function isTextDirectionRTL() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isTextDirectionRTL;
    }
    else {
        return false;
    }
}
export function isPrivacyConsentAccepted() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isPrivacyConsentAccepted;
    }
    else {
        return false;
    }
}
export function isInternetConnectionAvailable() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isInternetConnectionAvailable;
    }
    else {
        return true;
    }
}
export function networkCostConstraint() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.networkCostConstraint;
    }
    else {
        return "optIn";
    }
}
export async function addNetworkStatusChangedEventListener(networkStatusChanged) {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        dashboardHostApi.addEventListener("networkstatuschanged", networkStatusChanged);
    }
}
export async function removeNetworkStatusChangedEventListener(networkStatusChanged) {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        dashboardHostApi.removeEventListener("networkstatuschanged", networkStatusChanged);
    }
}
export function isWVVersionBlocked() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isWVVersionBlocked;
    }
    else {
        return false;
    }
}
export function isAppVersionBlocked() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isAppVersionBlocked;
    }
    else {
        return false;
    }
}
export function isOSVersionBlocked() {
    const dashboardHostApi = getDashboardHostApiInternal();
    if (dashboardHostApi) {
        return dashboardHostApi.isOSVersionBlocked;
    }
    else {
        return false;
    }
}
